import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function SEO({ 
  title, 
  description, 
  image = '/pressure_washing_hero.png',
  type = 'website',
  schema = null,
  canonical,
  keywords,
  author
}) {
  const location = useLocation();
  const siteUrl = 'https://coppercanyonpressurewash.com';
  const canonicalUrl = canonical || `${siteUrl}${location.pathname}`;

  // Ensure og:image is always an absolute URL
  const absoluteImageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet key={location.pathname}>
      {/* Basic Meta Tags */}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {author && <meta name="author" content={author} />}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph Tags */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      <meta property="og:image" content={absoluteImageUrl} />
      <meta property="og:url" content={canonicalUrl} />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={absoluteImageUrl} />
      
      {/* JSON-LD Schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}

export default SEO; 